import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SliceIcon = function SliceIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SliceIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m12.556 3.053-5.031 5.14v1.851l5.937-6.065zm-5.031 9.06 7.128-7.283a1.22 1.22 0 0 0 0-1.702l-1.24-1.267a1.2 1.2 0 0 0-1.715 0L1.345 12.437c-.724.74-.246 2.063.858 2.063H5.84c.946 0 1.684-.778 1.684-1.702zm-1.449-.294V9.672l-3.312 3.384h3.077c.114 0 .235-.1.235-.258z",
      clipRule: "evenodd"
    })
  }));
};

export { SliceIcon };
